export default __webpack_public_path__ + "static/media/quiz_bg_1.1b13476a.png";